import { createTypes, createAction } from 'lib/action'
const REMOVE_LISTS = `REMOVE_LISTS`
const LOAD_ONGOING = createTypes('isupplyongoing', 'load')
const LOAD_SUCCESS = createTypes('isupplysuccess', 'load')
const LOAD_AVALIABLE = createTypes('isupplyavailable', 'load')
const LOAD_ALL = createTypes('isupplyall', 'load')
const LOAD_AVALIABLE_FOR_EDIT = createTypes('isupplyavailableforedit', 'load')
const UPDATE_DATA_TRICKET = createTypes('isupplydeliveryedittricket', 'update')
const LOAD_DATA_VEHICLE_FOR_VIEW = createTypes(
  'isupplydashboardvehicle',
  'load'
)
const NEW_LOAD_DATA_DASHBORAD = createTypes('newisupplydashboard', 'load')
const RECALCULATOR_AREA_NOT_COVERED = createTypes(
  'recalculatorareanotcovered',
  'update'
)
const CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA = createTypes(
  'calculatordeliveryoutsidethearea',
  'update'
)
const CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION = createTypes(
  'createlogrequestchangedestlocation',
  'create'
)
const ISUPPLY_DASHBOARD_CLOSE_WORK = createTypes(
  'isupplydashboardclosework',
  'create'
)
// *Start ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ
const LOAD_DATA_ISUPPLY_DASHBOARD = createTypes(
  'loaddataisupplydashboard',
  'load'
)
// *End ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ

// *load detail ประเมินคุณภาพ (ต้นแหล่ง)
const SOURCE_QUALITY_CONTROL_LOG_DETAIL = createTypes(
  'sourceQualityControlLogLoadDetail',
  'load'
)

// *export 1 form ประเมินคุณภาพ
const SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM = createTypes(
  'sourceQualityControlLogExportOneForm',
  'export'
)

// *ดึง form ประเมินคุณภาพสินค้า
const ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM = createTypes(
  'isupplydashboardloadevaluationform',
  'load'
)
// *submit form ประเมินคุณภาพสินค้า
const ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM = createTypes(
  'isupplydashboardsubmitevaluationform',
  'create'
)

// *save image form ประเมินคุณภาพสินค้า
const ISUPPLY_DASHBOARD_SAVE_IMAGE_EVALUATION_FORM = createTypes(
  'isupplydashboardsaveimageevaluationform',
  'create'
)

// *เปลี่ยนต้นทางหลายรายการ
const ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE = createTypes(
  'isupplydashboardchangeoriginlocationmultiple',
  'update'
)

// *load division
const ISUPPLY_DASHBOARD_LOAD_DIVISION = createTypes(
  'isupplyDashboardLoadDivision',
  'load'
)

// *load department
const ISUPPLY_DASHBOARD_LOAD_DEPARTMENT = createTypes(
  'isupplyDashboardLoadDepartment',
  'load'
)

// *load section
const ISUPPLY_DASHBOARD_LOAD_SECTION = createTypes(
  'isupplyDashboardLoadSection',
  'load'
)

// *load plant
const ISUPPLY_DASHBOARD_LOAD_PLANT = createTypes(
  'isupplyDashboardLoadPlant',
  'load'
)

// *ส่ง GR อีกครั้ง
const ISUPPLY_DASHBOARD_RESEND_GR = createTypes(
  'isupplyDashboardResendGR',
  'create'
)

// *ค้นหาตั๋ว
const ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET = createTypes(
  'isupplyDashboardChangeDestSearchTicket',
  'load'
)

// *ประเมินสินค้าแบบรับสินค้าเปลี่ยนปลายทาง
const ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST = createTypes(
  'isupplyDashboardEvaluationFormChangeDest',
  'create'
)

// *export dp
const ISUPPLY_DASHBOARD_EXPORT_DP = createTypes(
  'isupplyDashboardExportDP',
  'export'
)

// *load check isupply source readiness confirm
const CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM = createTypes(
  'checkIsupplySourceReadinessConfirm',
  'load'
)

// *load isupply source readiness for manage
const ISUPPLY_SOURCE_READINESS_FOR_MANAGE = createTypes(
  'isupplySourceReadinessForManage',
  'load'
)

// *submit isupply source readiness
const UPDATE_ISUPPLY_SOURCE_READINESS = createTypes(
  'updateIsupplySourceReadinessForManage',
  'update'
)

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

const loadDataDashborad = {
  request: (data, loading) =>
    createAction(NEW_LOAD_DATA_DASHBORAD.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(NEW_LOAD_DATA_DASHBORAD.SUCCESS, { lists }),
  failure: () => createAction(NEW_LOAD_DATA_DASHBORAD.FAITLURE),
}
// *Start ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ
const loadDataIsupplyDashboard = {
  request: (data, loading) =>
    createAction(LOAD_DATA_ISUPPLY_DASHBOARD.REQUEST, { data, loading }),
  success: (lists, offset, group_by, check_load) =>
    createAction(LOAD_DATA_ISUPPLY_DASHBOARD.SUCCESS, {
      lists,
      offset,
      group_by,
      check_load,
    }),
  failure: () => createAction(LOAD_DATA_ISUPPLY_DASHBOARD.FAITLURE),
}
// *End ดึงข้อมูลมาแสดงหน้า Dashboard การขนส่งวัตถุดิบ

const loadOngoing = {
  request: (data, loading) =>
    createAction(LOAD_ONGOING.REQUEST, { data, loading }),
  success: (lists, page) => createAction(LOAD_ONGOING.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_ONGOING.FAITLURE),
}

const loadSuccess = {
  request: (data, loading) =>
    createAction(LOAD_SUCCESS.REQUEST, { data, loading }),
  success: (lists, page) => createAction(LOAD_SUCCESS.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_SUCCESS.FAITLURE),
}

const loadAvailable = {
  request: (data, loading) =>
    createAction(LOAD_AVALIABLE.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(LOAD_AVALIABLE.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_AVALIABLE.FAITLURE),
}

const loadWorkALL = {
  request: (data, loading) => createAction(LOAD_ALL.REQUEST, { data, loading }),
  success: (lists, page) => createAction(LOAD_ALL.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_ALL.FAITLURE),
}

const loadAvailableForEdit = {
  request: (data, loading, action_type) =>
    createAction(LOAD_AVALIABLE_FOR_EDIT.REQUEST, {
      data,
      loading,
      action_type,
    }),
  success: (lists) => createAction(LOAD_AVALIABLE_FOR_EDIT.SUCCESS, { lists }),
  failure: () => createAction(LOAD_AVALIABLE_FOR_EDIT.FAILURE),
}

const updateDataTricket = {
  request: (data, loading) =>
    createAction(UPDATE_DATA_TRICKET.REQUEST, { data, loading }),
  success: (res) => createAction(UPDATE_DATA_TRICKET.SUCCESS, { res }),
  failure: () => createAction(UPDATE_DATA_TRICKET.FAILURE),
}

const loadDataVehicleForView = {
  request: (data, loading) =>
    createAction(LOAD_DATA_VEHICLE_FOR_VIEW.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(LOAD_DATA_VEHICLE_FOR_VIEW.SUCCESS, { lists }),
  failure: () => createAction(LOAD_DATA_VEHICLE_FOR_VIEW.FAILURE),
}

const reCalculatorAreaNotCovered = {
  request: (data, loading) =>
    createAction(RECALCULATOR_AREA_NOT_COVERED.REQUEST, { data, loading }),
  success: (res) =>
    createAction(RECALCULATOR_AREA_NOT_COVERED.SUCCESS, { res }),
  failure: () => createAction(RECALCULATOR_AREA_NOT_COVERED.FAILURE),
}

const calculatorDeliveryOutsideTheArea = {
  request: (data, loading) =>
    createAction(CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA.REQUEST, {
      data,
      loading,
    }),
  success: (res) =>
    createAction(CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA.SUCCESS, { res }),
  failure: () => createAction(CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA.FAILURE),
}

const createLogRequestChangeDestLocation = {
  request: (data, loading) =>
    createAction(CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION.REQUEST, {
      data,
      loading,
    }),
  success: (res) =>
    createAction(CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION.SUCCESS, { res }),
  failure: () => createAction(CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION.FAILURE),
}

const isupplyDashboardCloseWork = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_CLOSE_WORK.REQUEST, {
      data,
      loading,
    }),
  success: (res) => createAction(ISUPPLY_DASHBOARD_CLOSE_WORK.SUCCESS, { res }),
  failure: () => createAction(ISUPPLY_DASHBOARD_CLOSE_WORK.FAILURE),
}

// *load detail ประเมินคุณภาพ (ต้นแหล่ง)
const sourceQualityControlLogLoadDetail = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_CONTROL_LOG_DETAIL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_CONTROL_LOG_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_CONTROL_LOG_DETAIL.FAITLURE),
}

// *export 1 form ประเมินคุณภาพ
const sourceQualityControlLogExportOneForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM.SUCCESS, { lists }),
  failure: () =>
    createAction(SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM.FAITLURE),
}

// *load form ประเมินคุณภาพสินค้า
const loadEvaluationForm = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (isupply_do_id, lists) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.SUCCESS, {
      isupply_do_id,
      lists,
    }),
  failure: () => createAction(ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM.FAITLURE),
}

// *submit form ประเมินคุณภาพสินค้า
const submitEvaluationForm = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.SUCCESS, { lists }),
  failure: () =>
    createAction(ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM.FAITLURE),
}

// *เปลี่ยนต้นทางหลายรายการ
const changeOriginLocationMultiple = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE.FAITLURE),
}

// *load division
const isupplyDashboardLoadDivision = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_DIVISION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_LOAD_DIVISION.FAITLURE),
}

// *load department
const isupplyDashboardLoadDepartment = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_LOAD_DEPARTMENT.FAITLURE),
}

// *load section
const isupplyDashboardLoadSection = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_SECTION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_LOAD_SECTION.FAITLURE),
}

// *load plant
const isupplyDashboardLoadPlant = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_LOAD_PLANT.FAITLURE),
}

// *ส่ง GR อีกครั้ง
const isupplyDashboardResendGR = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_RESEND_GR.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_RESEND_GR.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_RESEND_GR.FAITLURE),
}

// *ค้นหาตั๋ว
const isupplyDashboardChangeDestSearchTicket = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET.FAITLURE),
}

// *ประเมินสินค้าแบบรับสินค้าเปลี่ยนปลายทาง
const isupplyDashboardEvaluationFormChangeDest = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST.FAITLURE),
}

// *export dp
const isupplyDashboardExportDP = {
  request: (data, loading) =>
    createAction(ISUPPLY_DASHBOARD_EXPORT_DP.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_DASHBOARD_EXPORT_DP.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_DASHBOARD_EXPORT_DP.FAITLURE),
}

// *load isupply source readiness for manage
const loadIsupplySourceReadinessForManage = {
  request: (data, loading) =>
    createAction(ISUPPLY_SOURCE_READINESS_FOR_MANAGE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(ISUPPLY_SOURCE_READINESS_FOR_MANAGE.SUCCESS, { lists }),
  failure: () => createAction(ISUPPLY_SOURCE_READINESS_FOR_MANAGE.FAILURE),
}

// *update isupply source readiness
const updateIsupplySourceReadiness = {
  request: (data, loading) =>
    createAction(UPDATE_ISUPPLY_SOURCE_READINESS.REQUEST, {
      data,
      loading,
    }),
  success: (res) =>
    createAction(UPDATE_ISUPPLY_SOURCE_READINESS.SUCCESS, { res }),
  failure: () => createAction(UPDATE_ISUPPLY_SOURCE_READINESS.FAILURE),
}

const checkIsupplySourceReadinessConfirm = {
  request: (data, loading) =>
    createAction(CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.REQUEST, {
      data,
      loading,
    }),
  success: (data) =>
    createAction(CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.SUCCESS, { data }),
  failure: () => createAction(CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM.FAILURE),
}

export {
  NEW_LOAD_DATA_DASHBORAD,
  loadDataDashborad,
  LOAD_ONGOING,
  loadOngoing,
  LOAD_SUCCESS,
  loadSuccess,
  LOAD_AVALIABLE,
  loadAvailable,
  LOAD_ALL,
  loadWorkALL,
  LOAD_AVALIABLE_FOR_EDIT,
  loadAvailableForEdit,
  UPDATE_DATA_TRICKET,
  updateDataTricket,
  LOAD_DATA_VEHICLE_FOR_VIEW,
  loadDataVehicleForView,
  reCalculatorAreaNotCovered,
  RECALCULATOR_AREA_NOT_COVERED,
  calculatorDeliveryOutsideTheArea,
  CALCULATOR_DELIVERRY_OUTSIDE_THE_AREA,
  createLogRequestChangeDestLocation,
  CREATE_LOG_REQUEST_CHANGE_DEST_LOCATION,
  isupplyDashboardCloseWork,
  ISUPPLY_DASHBOARD_CLOSE_WORK,
  REMOVE_LISTS,
  removeLists,
  LOAD_DATA_ISUPPLY_DASHBOARD,
  loadDataIsupplyDashboard,
  SOURCE_QUALITY_CONTROL_LOG_DETAIL,
  sourceQualityControlLogLoadDetail,
  SOURCE_QUALITY_CONTROL_LOG_EXPORT_ONE_FORM,
  sourceQualityControlLogExportOneForm,
  ISUPPLY_DASHBOARD_LOAD_EVALUATION_FORM,
  loadEvaluationForm,
  ISUPPLY_DASHBOARD_SUBMIT_EVALUATION_FORM,
  submitEvaluationForm,
  ISUPPLY_DASHBOARD_CHANGE_ORIGIN_LOCATION_MULTIPLE,
  changeOriginLocationMultiple,
  ISUPPLY_DASHBOARD_LOAD_DIVISION,
  isupplyDashboardLoadDivision,
  ISUPPLY_DASHBOARD_LOAD_DEPARTMENT,
  isupplyDashboardLoadDepartment,
  ISUPPLY_DASHBOARD_LOAD_SECTION,
  isupplyDashboardLoadSection,
  ISUPPLY_DASHBOARD_LOAD_PLANT,
  isupplyDashboardLoadPlant,
  ISUPPLY_DASHBOARD_RESEND_GR,
  isupplyDashboardResendGR,
  ISUPPLY_DASHBOARD_CHANGE_DEST_SEARCH_TICKET,
  isupplyDashboardChangeDestSearchTicket,
  ISUPPLY_DASHBOARD_EVALUATION_FORM_CHANGE_DEST,
  isupplyDashboardEvaluationFormChangeDest,
  ISUPPLY_DASHBOARD_EXPORT_DP,
  isupplyDashboardExportDP,
  ISUPPLY_SOURCE_READINESS_FOR_MANAGE,
  loadIsupplySourceReadinessForManage,
  UPDATE_ISUPPLY_SOURCE_READINESS,
  updateIsupplySourceReadiness,
  CHECK_ISUPPLY_SOURCE_READINESS_CONFIRM,
  checkIsupplySourceReadinessConfirm,
}
